import React, { useState, createContext, useContext } from 'react';

import { languageOptions, dictionaryList } from '../languages';

// create the language context with default selected language
export const LanguageContext = createContext({
  userLanguage: 'en',
  dictionary: dictionaryList.en,
  usingRtl: false
});

// it provides the language context to app
export function LanguageProvider({ children }) {
  const [userLanguage, setUserLanguage] = useState('en');
  const [usingRtl, setUsingRtl] = useState(false);

  const provider = {
    userLanguage,
    dictionary: dictionaryList[userLanguage],
    usingRtl,
    userLanguageChange: selected => {
      const newLanguage = languageOptions[selected] ? selected : 'en';

      if (newLanguage === 'ar')
        setUsingRtl(true);
      else
        setUsingRtl(false);

      setUserLanguage(newLanguage);
      window.localStorage.setItem('rcml-lang', newLanguage);
    }
  };

  return (
    <LanguageContext.Provider value={provider}>
      {children}
    </LanguageContext.Provider>
  );
};

// get text according to id & current language
export function Text({ tid }) {
  const languageContext = useContext(LanguageContext);

  return languageContext.dictionary[tid] || tid;
};
